"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const info_1 = require("../icons/info");
exports.default = info_1.Info;
